/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Edit_Logon_NameInputs */

const en_forms_users_edit_logon_name = /** @type {(inputs: Forms_Users_Edit_Logon_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logon Name`)
};

const de_forms_users_edit_logon_name = /** @type {(inputs: Forms_Users_Edit_Logon_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldename`)
};

/**
* | output |
* | --- |
* | "Logon Name" |
*
* @param {Forms_Users_Edit_Logon_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_edit_logon_name = /** @type {((inputs?: Forms_Users_Edit_Logon_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Edit_Logon_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_edit_logon_name(inputs)
	return de_forms_users_edit_logon_name(inputs)
});